import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PaginatedEnsueCollection } from "../../../../../../../ensue-react-system/utilities/paginated-ensue-collection";
import { ManageFootballPlayer } from "../../../../../../../commons/models/football/admin/manage-football-player";
import { StatusEnum } from "../../../../../../../commons/enums/status-enum";
import { manageFootballTeamService } from "../../../../../../../commons";

export interface ISubTeamPlayersAvailableOptions {
  teamId: number;
  subTeamId: number;
  urlOption?: {
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
    status?: string;
  };
}
export interface IManageSubTeamPlayersAvailableState {
  subTeamPlayersAvailable: PaginatedEnsueCollection<ManageFootballPlayer>;
  subTeamPlayersAvailableStatus: StatusEnum;
}

const initialState: IManageSubTeamPlayersAvailableState = {
  subTeamPlayersAvailable: new PaginatedEnsueCollection<ManageFootballPlayer>(),
  subTeamPlayersAvailableStatus: StatusEnum.Idle,
};

export const fetchManageSubTeamPlayersAvailable = createAsyncThunk(
  "manage/subTeamPlayersAvailable",
  async (options: ISubTeamPlayersAvailableOptions, thunkAPI) => {
    try {
      const playersNotInTeam = await manageFootballTeamService.getPlayersAvailableForSubTeam(
        options.teamId,
        options.subTeamId,
        options.urlOption
      );
      return playersNotInTeam as PaginatedEnsueCollection<ManageFootballPlayer>;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageSubTeamPlayersAvailableSlice = createSlice({
  name: "footballManageSubTeamPlayersAvailable",
  initialState: initialState,
  reducers: {
    cleanUpSubTeamPlayersAvailable(state) {
      state.subTeamPlayersAvailable = new PaginatedEnsueCollection<ManageFootballPlayer>();
      state.subTeamPlayersAvailableStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageSubTeamPlayersAvailable.pending, (state) => {
        state.subTeamPlayersAvailableStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageSubTeamPlayersAvailable.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<ManageFootballPlayer>>) => {
          state.subTeamPlayersAvailableStatus = StatusEnum.Succeeded;
          state.subTeamPlayersAvailable = action.payload;
        }
      )
      .addCase(fetchManageSubTeamPlayersAvailable.rejected, (state) => {
        state.subTeamPlayersAvailableStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSubTeamPlayersAvailable } = footballManageSubTeamPlayersAvailableSlice.actions;
export default footballManageSubTeamPlayersAvailableSlice.reducer;
